module.exports = __webpack_public_path__ + "static/img/sunglasses.d2499b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/sunglasses.png
// module id = kqev
// module chunks = 0